// Helpers for the AI chat: keep what we send within the server's limits (api/ai-chat.js).
export const MAX_SEND_MESSAGES = 30;
export const MAX_SEND_CHARS = 40000;
export const MAX_MESSAGE_CHARS = 8000;
export const MAX_PROMPT_CHARS = 115000;

// The messages to send: no error replies, newest messages that fit, starting with a user turn.
// The full list stays in the screen state for display.
export function trimHistoryForSend(messages) {
  const kept = (messages || [])
    .filter(m => m && !m.isError)
    .map(m => ({ role: m.role, content: m.content }))
    // Over-long earlier messages would make every later send fail, so skip them.
    // The newest one stays so the server can still say "too long" for what was just sent.
    .filter((m, i, all) => m.content.length <= MAX_MESSAGE_CHARS || i === all.length - 1);
  let total = kept.reduce((n, m) => n + m.content.length, 0);
  while (kept.length > 0 && (kept.length > MAX_SEND_MESSAGES || total > MAX_SEND_CHARS)) {
    total -= kept.shift().content.length;
  }
  while (kept.length > 0 && kept[0].role !== 'user') kept.shift();
  return kept;
}

// Builds the system prompt with compact JSON. If it is too big, keeps only the most recent
// jobs that fit (by lastDate, newest first; original order if no dates) and says so.
export function buildSystemPrompt(intro, jobRows, trend, maxChars = MAX_PROMPT_CHARS) {
  const trendText = JSON.stringify(trend);
  const build = (jobs, note) =>
    `${intro}\n\n${note}JOB SUMMARY DATA:\n${JSON.stringify(jobs)}\n\nMONTHLY TREND DATA:\n${trendText}`;

  const all = jobRows || [];
  const full = build(all, '');
  if (full.length <= maxChars) return full;

  const ordered = all.some(j => j && j.lastDate)
    ? all.map((j, i) => [j, i]).sort((a, b) =>
        String(b[0].lastDate || '').localeCompare(String(a[0].lastDate || '')) || a[1] - b[1]).map(x => x[0])
    : all;
  const attempt = n => build(ordered.slice(0, n), `Note: only the ${n} most recent jobs are included below.\n\n`);
  let lo = 0, hi = ordered.length - 1;
  while (lo < hi) {
    const mid = Math.ceil((lo + hi) / 2);
    if (attempt(mid).length <= maxChars) lo = mid; else hi = mid - 1;
  }
  return attempt(lo);
}
